import type { Palette } from '@mui/material';
import type { TextStyleTokens } from '../../../../utils/richText/textStyles';

export const paletteToTokens = (palette: Palette): TextStyleTokens => ({
  primary: palette.primary.main,
  secondary: palette.secondary.main,
  muted: palette.text.secondary,
});
